"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog from "@/components/dialog/UiDialog.vue";
import ProgressComponent from "@/components/progress/Progress.vue";
let VersionConfig = class extends Vue {
  constructor() {
    super(...arguments);
    //   当前客户端版本号
    this.version = "";
    //   检查更新状态
    this.updateStatus = "check";
    //   显示的更新内容
    this.upgrade = null;
    //   更新按钮loading
    this.update_loading = false;
    //   安装提示窗弹出的同步锁
    this.showLock = false;
    //   下载提示弹窗的同步锁
    this.showUpdate = false;
    //   下载提示弹窗对象
    this.notify = null;
    // browser_list
    this.browserList = [];
    this.deleteLoading = false;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkVersion();
    });
  }
  //   获取当前客户端版本
  checkVersion() {
    return __async(this, null, function* () {
      try {
        this.browserList = [];
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/chrome/versions/106`);
          let browser_item = {
            "name": "KuaJingVSBrowser",
            "core": "chrome",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/chrome/versions/122`);
          let browser_item = {
            "name": "KuaJingVSBrowser",
            "core": "chrome",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/chrome/versions/126`);
          let browser_item = {
            "name": "KuaJingVSBrowser",
            "core": "chrome",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/chrome/versions/130`);
          let browser_item = {
            "name": "KuaJingVSBrowser",
            "core": "chrome",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/firefox/versions/111`);
          let browser_item = {
            "name": "KuaJingVSFirefox",
            "core": "firefox",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
        try {
          let response = yield API.get(`api://base.local/v2/dynamic-browsers/brands/firefox/versions/134`);
          let browser_item = {
            "name": "KuaJingVSFirefox",
            "core": "firefox",
            "version": response.data.version,
            "subVersion": response.data.sub_version
          };
          this.browserList.push(browser_item);
        } catch (error) {
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  deleteBrowser(item) {
    return __async(this, null, function* () {
      try {
        this.deleteLoading = true;
        yield API.delete(
          `api://base.local/v2/dynamic-browsers/private/brands/${item.core}/versions/${item.version}`
        );
        yield this.refresh();
      } catch (error) {
      } finally {
        this.deleteLoading = false;
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      try {
        yield this.checkVersion();
      } catch (error) {
      }
    });
  }
};
__decorateClass([
  Ref("update-dialog")
], VersionConfig.prototype, "_update_dialog", 2);
VersionConfig = __decorateClass([
  Component({
    components: { UiDialog, ProgressComponent }
  })
], VersionConfig);
export {
  VersionConfig as default
};
